/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ([
/* 0 */,
/* 1 */
/***/ (() => {

var body = document.querySelector('body');
window.openDrawerCart = function (drawer_id) {
  var validate = false;
  if ($('.page-product-product .product-options-list').length > 0) {
    if ($('.page-product-product .product-options-list').find('input.selected').length) {
      validate = true;
    }
  } else {
    validate = true;
  }
  if (validate || drawer_id !== 'button-cart-product') {
    $('#launcher').css('z-index', '99');
    $('#launcher').closest('div').find('div:first-child').css('z-index', '99');
    drawer_id = 'page-header-cart';
    body.classList.add('drawer_is_opened');
    var drawer = document.getElementById(drawer_id);
    drawer.setAttribute('open', true);
  }
};
window.openDrawerAccount = function (element) {
  $(element).toggleClass('open-account');
};
window.openDrawer = function (drawer_id) {
  $('#launcher').css('z-index', '99');
  $('#launcher').closest('div').find('div:first-child').css('z-index', '99');
  body.classList.add('drawer_is_opened');
  var drawer = document.getElementById(drawer_id);
  drawer.setAttribute('open', true);
};
window.closeDrawer = function (drawer_id) {
  $('#launcher').css('z-index', '999999');
  $('#launcher').closest('div').find('div:first-child').css('z-index', '999999');
  body.classList.remove('drawer_is_opened');
  var drawer = document.getElementById(drawer_id);
  drawer.removeAttribute('open');
};
window.openSearch = function () {
  $('body, .page-header-content__container .page-header-account--desktop').removeClass('open-account');
  $('body, .page-header-content__container #search fieldset').addClass('open-search');
};
window.closeSearch = function () {
  $('body, .page-header-content__container #search fieldset').removeClass('open-search');
};
window.addEventListener('openCartEvent', function (event) {
  openDrawerCart('page-header-cart');
});
window.openFilters = function () {
  $('body').addClass('open-filters');
};
window.closeFilters = function () {
  $('body').removeClass('open-filters');
};
var $filterOptions = $('#content-filters-v2--left .filter-title');
$filterOptions.on('click', function () {
  $(this).toggleClass('open-filter');
  $(this).siblings('.filter-option-list, .filter-price-list, .filter-custom-list').toggleClass('open-filter');
});
if (screen.width <= 1199) {
  $('#search_mobile input[name="search"]').parent().find('button').on('click', function () {
    var url = $('base').attr('href') + $(this).parent().parent().find('input[name="search"]').attr('data-url');
    var value = $(this).parent().parent().find('input[name="search"]').val();
    if (value) {
      url += '?search=' + encodeURIComponent(value);
      location = url;
    }
  });
  $('#search_mobile input[name="search"]').on('keydown', function (e) {
    if (e.keyCode == 13) {
      $(this).parent().find('button').trigger('click');
    }
  });
}
$(window).on('scroll', function () {
  if ($(this).scrollTop() > 0) {
    $('.page-header').addClass('scroll');
  } else if ($(this).scrollTop() == 0) {
    $('.page-header').removeClass('scroll');
  }
});

/**
 * Altera a imagem dinâmica do painel principal de categorias
 * ao passar o mouse sobre qualquer nível de subcategoria.
 * A imagem estática (categoria principal) sempre permanece visível.
 * Funciona para até 4 níveis de categorias.
 */
function handleCategoryImageChange() {
  // Seletores para todos os níveis de subcategorias
  var selectors = ['.page-header-categories__items--sub', '.page-header-categories__items--sub-sub'];

  // Verifica se há imagens nos subitens, exibe a dinâmica e carrega a primeira imagem disponível
  function initializeDynamicImage($rootDetails) {
    var $firstItemWithImage = $rootDetails.find('[data-image]').first();
    var hasImages = $firstItemWithImage.length > 0;
    var $dynamicImage = $rootDetails.find('.page-header-categories__image--dynamic');
    var $staticImage = $rootDetails.find('.page-header-categories__image--static');
    var $images = $rootDetails.find('.page-header-categories__images');
    var $img = $dynamicImage.find('img');
    var $link = $dynamicImage.find('a');
    var $title = $dynamicImage.find('span');
    if (hasImages) {
      // Mostra a imagem dinâmica
      $dynamicImage.show();
      $images.removeClass('has-only-static');

      // Carrega a primeira imagem disponível
      var src = $firstItemWithImage.data('image');
      var linkSrc = $firstItemWithImage.find('a').first().attr('href');
      var hoveredName = $firstItemWithImage.find('> .page-header-categories__link a, > .details .summary a').first().text().trim();

      // Atualiza a imagem, link e texto com o primeiro item
      $img.attr('src', src);
      $link.attr('href', linkSrc);
      if (hoveredName) {
        $title.text(hoveredName);
      }

      // Armazena os dados originais
      $rootDetails.data('_original-src', src);
      $rootDetails.data('_original-text', hoveredName || '');
      $rootDetails.data('_original-href', linkSrc);
    } else {
      $dynamicImage.hide();
      $images.addClass('has-only-static');
    }
  }
  selectors.forEach(function (selector) {
    $(document).on('mouseenter', selector, function () {
      var $this = $(this);
      var $rootDetails = $this.closest('.page-header-categories__details');

      // Se não encontrar .page-header-categories__details, para
      if (!$rootDetails.length) return;
      var $dynamicImage = $rootDetails.find('.page-header-categories__image--dynamic');
      var $img = $dynamicImage.find('img');
      var $link = $dynamicImage.find('a');
      var $title = $dynamicImage.find('span');
      var src = $this.data('image');
      var linkSrc = $this.find('a').first().attr('href');
      var originalSrc = $rootDetails.data('_original-src');
      var originalLinkSrc = $rootDetails.data('_original-href');

      // Atualiza o título com o nome da categoria/subcategoria
      if ($title.length) {
        var hoveredName = $this.find('> .page-header-categories__link a, > .details .summary a').first().text().trim();
        if (hoveredName) {
          $title.text(hoveredName);
        }
      }

      // Atualiza o link
      $link.attr('href', linkSrc || originalLinkSrc);

      // Se não há imagem ou é a mesma da original, retorna
      if (!src && $img.attr('src') === originalSrc) return;

      // Troca a imagem com efeito de carregamento
      $img.addClass('loading');
      $img.one('load', function () {
        $img.removeClass('loading');
      });
      $img.on('error', function () {
        $img.removeClass('loading');
      });
      $img.attr('src', src || originalSrc);
    });
  });

  // Ao sair do painel de categorias, retorna para o padrão
  $(document).on('mouseleave', '.page-header-categories__details', function () {
    var $details = $(this);
    var $dynamicImage = $details.find('.page-header-categories__image--dynamic');
    var $img = $dynamicImage.find('img');
    var $title = $dynamicImage.find('span');
    var $link = $dynamicImage.find('a');

    // Restaura valores originais armazenados
    var originalText = $details.data('_original-text');
    var originalSrc = $details.data('_original-src');
    var originalLinkSrc = $details.data('_original-href');

    // Restaura o título original
    if ($title.length && originalText) {
      $title.text(originalText);
    }

    // Restaura o link original
    if (originalLinkSrc) {
      $link.attr('href', originalLinkSrc);
    }

    // Restaura a imagem original
    if (!$img.length || !originalSrc) return;
    $img.addClass('loading');
    $img.one('load', function () {
      $img.removeClass('loading');
    });
    $img.on('error', function () {
      $img.removeClass('loading');
    });
    $img.attr('src', originalSrc);
  });

  // Inicializa a imagem dinâmica para cada categoria
  $('.page-header-categories__details').each(function () {
    initializeDynamicImage($(this));
  });
}
$(function () {
  handleCategoryImageChange();
});

/***/ }),
/* 2 */
/***/ (() => {

/*
 * ========================================
 * CARRINHO: Sistema Modular de Adição ao Carrinho
 * ========================================
 * Consolidado em uma única estrutura reutilizável
 * para as 3 rotas: Botão de compra, Compre junto c/ variações, Compre junto s/ variações
 */

var CartManager = {
  ENDPOINT: "index.php?route=checkout/cart/addCartMultipleOptions",
  DEBOUNCE_MS: 350,
  debounceTimers: {},
  /*
   * Função genérica unificada para enviar produto ao carrinho
   * Reutilizada por todas as 3 rotas diferentes
   */
  sendToCart: function sendToCart(payload) {
    var ui = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (!payload || !payload.options || payload.options.length === 0) {
      showFloatingMessageCustom("Por favor, selecione as opções do produto antes de adicionar ao carrinho.", "error");
      ui.onError({
        error: "empty_options"
      });
      ui.onComplete();
      return $.Deferred().reject("empty_options");
    }
    return $.ajax({
      url: this.ENDPOINT + "&redirect=0&v=" + Date.now(),
      type: "POST",
      dataType: "json",
      data: payload,
      success: function success(json) {
        if (json.error || json.error_stock) {
          var msg = json.error ? json.error.option ? Object.values(json.error.option)[0] : json.error.product || json.error.empty_option || "Erro ao adicionar produto." : json.error_stock;
          showFloatingMessageCustom(msg, "error");
          ui.onError(json);
          return;
        }
        try {
          refreshCart();
        } catch (e) {
          console.error("Função refreshCart() não disponível.");
        }
        if (typeof showFloatingMessageCustom === "function") {
          showFloatingMessageCustom("Adicionado ao carrinho.", "success");
          openDrawerCart("page-header-cart");
        } else {
          showFloatingMessageCustom("Produto adicionado ao carrinho.", "success");
        }
        ui.onSuccess(json);
      },
      error: function error() {
        console.error("Falha na comunicação com o servidor.");
        ui.onError();
      },
      complete: function complete() {
        ui.onComplete();
      }
    });
  },
  /*
   * Debounce helper para evitar múltiplas requisições
   */
  debounce: function debounce(key, fn) {
    var ms = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.DEBOUNCE_MS;
    clearTimeout(this.debounceTimers[key]);
    this.debounceTimers[key] = setTimeout(fn, ms);
  },
  /*
   * Helper: Injetar estilos CSS uma única vez
   */
  injectStyles: function injectStyles(id, css) {
    if (document.getElementById(id)) return;
    var style = document.createElement("style");
    style.id = id;
    style.innerHTML = css;
    document.head.appendChild(style);
  }
};

/*
 * Compatibilidade retroativa: função global que delegam para CartManager
 */
function sendToCartUnified(payload) {
  var ui = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return CartManager.sendToCart(payload, ui);
}

/*
 * ========================================
 * BUILDERS: Constroem payloads para cada contexto
 * ========================================
 */

var PayloadBuilders = {
  /*
   * Build payload para compre junto com select (variações)
   */
  buyTogetherWithVariations: function buyTogetherWithVariations(productId, $container) {
    var csrf = $('[name="__csrf"]').val();
    var payload = {
      product_id: productId,
      recurring_id: 0,
      __csrf: csrf || undefined,
      options: []
    };
    $container.find(".select_list select.option_type_select").each(function () {
      var $select = $(this);
      var selected = $select.find("option:selected");
      var val = selected.val();
      if (!val || val === "0" || val === "size_no_available") return;
      var optionObj = {
        name: $select.data("option-name"),
        required: $select.data("option-required"),
        product_option_id: $select.data("product-option-id"),
        principal: $select.data("principal"),
        product_option_value: [{
          product_option_value_id: selected.data("product-option-value-id"),
          quantity: 1,
          stock_type: selected.data("option-stock-type"),
          package_term: selected.data("option-package")
        }]
      };
      payload.options.push(optionObj);
    });
    return payload;
  },
  /*
   * Build payload para botão de compra na página do produto
   */
  productPageButton: function productPageButton() {
    var csrf = $("#__csrf").val() || $('[name="__csrf"]').val();
    var productId = $('input[name="product_id"]').val() || $('[name="product_id"]').val();
    if (!productId) return null;
    var payload = {
      product_id: productId,
      recurring_id: 0,
      __csrf: csrf || undefined,
      options: []
    };

    /*
     * Tenta encontrar opção selecionada: .product_options_list ou .sizes
     * Exclui elementos dentro de .buy-together
     */
    var $selectedLi = $("#product .product_options_list li.selected, #product .sizes li.selected").first();
    if ($selectedLi.length) {
      var opt = {
        name: $selectedLi.closest(".product_options_list").data("option-name") || "Tamanho",
        required: $selectedLi.closest(".product_options_list").data("option-required") || 1,
        product_option_id: $selectedLi.data("product-option-id") || $selectedLi.closest("[data-product-option-id]").data("product-option-id"),
        principal: $selectedLi.closest(".product_options_list").data("principal") || 1,
        product_option_value: [{
          product_option_value_id: $selectedLi.data("product-option-value-id"),
          quantity: 1,
          stock_type: $selectedLi.data("option-stock-type") || $selectedLi.attr("data-option-stock-type"),
          package_term: $selectedLi.data("option-package") || $selectedLi.attr("data-option-package") || 0
        }]
      };
      payload.options.push(opt);
      return payload;
    }

    /*
     * Tenta encontrar input único
     * Exclui elementos dentro de .buy-together
     */
    var $unique = $('#product .uniqueInputValue, #product input.uniqueInputValue, #product [id^="input-option"] .uniqueInputValue').first();
    if (!$unique.length) {
      var $hiddenCandidate = $('#product input[type="hidden"][data-product-option-value-id]').first();
      if ($hiddenCandidate.length) $unique = $hiddenCandidate;
    }
    if ($unique && $unique.length) {
      var product_option_id = $unique.data("product-option-id") || $unique.closest("[data-product-option-id]").data("product-option-id");
      if (!product_option_id) {
        var $parentWithData = $unique.closest('[id^="input-option"], [data-product-option-id]');
        product_option_id = $parentWithData.data("product-option-id") || product_option_id;
      }
      var povId = $unique.data("product-option-value-id") || $unique.attr("data-product-option-value-id") || $unique.val();
      if (product_option_id && povId) {
        var _opt = {
          name: $unique.closest('[id^="input-option"]').data("option-name") || "Único",
          required: $unique.closest('[id^="input-option"]').data("option-required") || 1,
          product_option_id: product_option_id,
          principal: $unique.closest('[id^="input-option"]').data("principal") || 1,
          product_option_value: [{
            product_option_value_id: povId,
            quantity: 1,
            stock_type: $unique.data("option-stock-type") || $unique.attr("data-option-stock-type") || "warn_me",
            package_term: $unique.data("option-package") || $unique.attr("data-option-package") || 0
          }]
        };
        payload.options.push(_opt);
        return payload;
      }
    }

    /*
     * Tenta encontrar selects
     * Exclui elementos dentro de .buy-together
     */
    var $selects = $("#product .select_list select.option_type_select, #product select[data-product-option-id], #product select.product-option-select");
    if ($selects.length) {
      $selects.each(function () {
        var $s = $(this);
        var selected = $s.find("option:selected");
        var val = selected.val();
        if (!val || val === "0" || val === "size_no_available") return;
        var opt = {
          name: $s.data("option-name") || $s.attr("data-option-name") || $s.closest(".select_list").data("option-name") || "Option",
          required: $s.data("option-required") || 1,
          product_option_id: $s.data("product-option-id") || $s.attr("data-product-option-id"),
          principal: $s.data("principal") || 1,
          product_option_value: [{
            product_option_value_id: selected.data("product-option-value-id") || selected.attr("data-product-option-value-id") || val,
            quantity: 1,
            stock_type: selected.data("option-stock-type") || selected.attr("data-option-stock-type") || "warn_me",
            package_term: selected.data("option-package") || selected.attr("data-option-package") || 0
          }]
        };
        payload.options.push(opt);
      });
      if (payload.options.length) return payload;
    }
    return payload;
  },
  /*
   * Build payload para produtos sem variações
   */
  productWithoutVariations: function productWithoutVariations(productId, $container) {
    var csrf = $('[name="__csrf"]').val();
    var payload = {
      product_id: productId,
      recurring_id: 0,
      __csrf: csrf || undefined,
      options: []
    };
    var $input = $container.find("input[data-product-option-id]");
    if ($input.length) {
      $input.each(function () {
        var $el = $(this);
        var optionObj = {
          name: $el.data("option-name") || "Opção",
          required: $el.data("option-required") || 1,
          product_option_id: $el.data("product-option-id"),
          principal: $el.data("principal") || 1,
          product_option_value: [{
            product_option_value_id: $el.val(),
            quantity: 1,
            stock_type: $el.data("option-stock-type") || "warn_me",
            package_term: $el.data("option-package") || 0
          }]
        };
        payload.options.push(optionObj);
      });
    }
    return payload;
  }
};

/*
 * ========================================
 * UI HANDLERS: Animações e feedback visual
 * ========================================
 */

var UIHandlers = {
  SELECT_ARROW_BG: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='15' height='8' viewBox='0 0 15 8' fill='none'%3E%3Cpath d='M-0.000797272 0.823405C-0.000797272 0.613231 0.0792542 0.402213 0.240662 0.24119C0.562248 -0.0803967 1.08266 -0.0803967 1.40425 0.24119L7.10501 5.94234L12.8062 0.24119C13.1277 -0.0803967 13.6486 -0.0803967 13.9697 0.24119C14.2913 0.562777 14.2913 1.08365 13.9697 1.40516L7.68723 7.68768C7.36564 8.00926 6.84477 8.00926 6.52364 7.68768L0.240739 1.40516C0.0797148 1.24467 -0.000797272 1.03404 -0.000797272 0.823405Z' fill='black'/%3E%3C/svg%3E\")",
  /*
   * Mostrar sucesso inline no select (compre junto com variações)
   */
  showSelectSuccess: function showSelectSuccess($select) {
    var $wrap = $select.closest(".form-group.select_list");
    if (!$wrap.length) return;
    if ($wrap.css("position") === "static") $wrap.css("position", "relative");
    $wrap.find(".bt-inline-success").remove();
    var icon = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"12\" viewBox=\"0 0 16 12\" fill=\"none\"><path d=\"M5.28846 8.775L13.7635 0.3C13.9635 0.1 14.1968 0 14.4635 0C14.7301 0 14.9635 0.1 15.1635 0.3C15.3635 0.5 15.4635 0.737667 15.4635 1.013C15.4635 1.28833 15.3635 1.52567 15.1635 1.725L5.98846 10.925C5.78846 11.125 5.55513 11.225 5.28846 11.225C5.02179 11.225 4.78846 11.125 4.58846 10.925L0.288462 6.625C0.0884617 6.425 -0.00753846 6.18767 0.000461538 5.913C0.00846154 5.63833 0.112795 5.40067 0.313461 5.2C0.514128 4.99933 0.751795 4.89933 1.02646 4.9C1.30113 4.90067 1.53846 5.00067 1.73846 5.2L5.28846 8.775Z\" fill=\"white\"/></svg>";
    var $msg = $('<div class="bt-inline-success" role="status" aria-live="polite"></div>').html("<span>Adicionado ao carrinho</span>" + icon);
    var originalVisibility = $select.css("visibility");
    $select.css("visibility", "hidden");
    var br = $select.css("border-radius");
    if (br) $msg.css("border-radius", br);
    $wrap.append($msg);
    var pos = $select.position();
    var width = $select.width();
    var height = $select.height();
    $msg.css({
      top: pos.top,
      left: pos.left,
      width: width,
      height: height
    });
    requestAnimationFrame(function () {
      return $msg.addClass("show");
    });
    setTimeout(function () {
      $msg.addClass("hide");
      setTimeout(function () {
        $msg.remove();
        $select.css("visibility", originalVisibility);
      }, 280);
    }, 5000);
  },
  /*
   * Mostrar sucesso inline em botão (compre junto sem variações)
   */
  showButtonSuccess: function showButtonSuccess($button, originalText) {
    var $wrap = $button.closest(".buy-together-option-list");
    if (!$wrap.length) return;
    if ($wrap.css("position") === "static") $wrap.css("position", "relative");
    $wrap.find(".bt-inline-success").remove();
    var icon = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"12\" viewBox=\"0 0 16 12\" fill=\"none\"><path d=\"M5.28846 8.775L13.7635 0.3C13.9635 0.1 14.1968 0 14.4635 0C14.7301 0 14.9635 0.1 15.1635 0.3C15.3635 0.5 15.4635 0.737667 15.4635 1.013C15.4635 1.28833 15.3635 1.52567 15.1635 1.725L5.98846 10.925C5.78846 11.125 5.55513 11.225 5.28846 11.225C5.02179 11.225 4.78846 11.125 4.58846 10.925L0.288462 6.625C0.0884617 6.425 -0.00753846 6.18767 0.000461538 5.913C0.00846154 5.63833 0.112795 5.40067 0.313461 5.2C0.514128 4.99933 0.751795 4.89933 1.02646 4.9C1.30113 4.90067 1.53846 5.00067 1.73846 5.2L5.28846 8.775Z\" fill=\"white\"/></svg>";
    var $msg = $('<div class="bt-inline-success" role="status" aria-live="polite"></div>').html("<span>Adicionado ao carrinho</span>" + icon);
    var originalVisibility = $button.css("visibility");
    $button.css("visibility", "hidden");
    var br = $button.css("border-radius");
    if (br) $msg.css("border-radius", br);
    $wrap.append($msg);
    var pos = $button.position();
    var width = $button.outerWidth();
    var height = $button.outerHeight();
    $msg.css({
      top: pos.top,
      left: pos.left,
      width: width,
      height: height
    });
    requestAnimationFrame(function () {
      return $msg.addClass("show");
    });
    setTimeout(function () {
      $msg.addClass("hide");
      setTimeout(function () {
        $msg.remove();
        $button.css("visibility", originalVisibility).prop("disabled", false).text(originalText).css("opacity", "1");
      }, 250);
    }, 2000);
  },
  /*
   * Adicionar spinner em select
   */
  addSelectSpinner: function addSelectSpinner($select) {
    var $wrap = $select.closest(".form-group.select_list");
    if (!$wrap.length) return;
    if ($wrap.css("position") === "static") $wrap.css("position", "relative");
    var $sp = $('<div class="bt-select-spinner" aria-hidden="true"></div>');
    $wrap.append($sp);
    var pos = $select.position();
    var width = $select.outerWidth();
    var height = $select.outerHeight();
    $sp.css({
      top: pos.top + (height - 16) / 2,
      left: pos.left + width - 26
    });
  },
  /*
   * Remover spinners
   */
  removeSelectSpinners: function removeSelectSpinners($container) {
    $container.find(".bt-select-spinner").remove();
  }
};

/*
 * ========================================
 * INICIALIZAÇÃO: Começar quando DOM está pronto
 * ========================================
 */
$(function () {
  /*
   * SEÇÃO 1: Compre junto com variações (selects)
   */
  (function initBuyTogetherWithVariations() {
    CartManager.injectStyles("bt-loading-styles", "\n      .bt-loading { cursor: wait; opacity:.85; }\n      .bt-select-spinner { position:absolute; width:16px; height:16px; border:2px solid rgba(0,0,0,.25); border-top-color: rgba(0,0,0,.7); border-radius:50%; animation: btSpin .7s linear infinite; pointer-events:none; z-index: 2; }\n      @keyframes btSpin { to { transform: rotate(360deg); } }\n      .bt-inline-success {\n        position: absolute; top: 0; left: 0; width: 100%; height: 100%;\n        background: var(--cl-green); color: #fff; padding: 0 12px; border-radius: 6px; \n        display: flex; align-items: center; justify-content: center; gap: 8px;\n        font-size: 16px; line-height: 1; opacity: 0; transform: scale(.95);\n        transition: opacity .25s ease, transform .25s ease; pointer-events: none;\n      }\n      .bt-inline-success svg { width: 16px; height: 16px; flex: 0 0 16px; }\n      .bt-inline-success.show { opacity: 1; transform: scale(1); }\n      .bt-inline-success.hide { opacity: 0; transform: scale(.95); }\n    ");
    $(document).on("change", ".buy-together .select_list select.option_type_select", function (e) {
      var $select = $(e.target);

      /*Garantir que o elemento é .buy-together e não no produto principal*/
      if (!$select.closest(".buy-together").length) return;
      var value = $select.val();
      var productId = $select.find("option:selected").data("product-id");
      if (!value || value === "0") return;
      if (value === "size_no_available") {
        showFloatingMessageCustom("Variação indisponível.", "error");
        return;
      }
      var $productContainer = $select.closest(".buy-together");
      var payload = PayloadBuilders.buyTogetherWithVariations(productId, $productContainer);
      if (!payload || !payload.options || payload.options.length === 0) {
        showFloatingMessageCustom("Por favor, selecione as opções do produto.", "error");
        return;
      }
      CartManager.debounce("buy-together-".concat(productId), function () {
        var $selects = $productContainer.find(".select_list select.option_type_select");
        $selects.each(function () {
          var $s = $(this);
          $s.prop("disabled", true).addClass("bt-loading");
          UIHandlers.addSelectSpinner($s);
        });
        var flashSuccess = function flashSuccess() {
          var originalBgColor = "var(--cl-white)";
          var originalColor = $select.css("color");
          $select.css({
            "background-color": "var(--cl-green)",
            color: "#fff"
          });
          setTimeout(function () {
            $select.css({
              "background-color": originalBgColor,
              color: originalColor,
              "background-image": UIHandlers.SELECT_ARROW_BG
            });
          }, 1200);
          UIHandlers.showSelectSuccess($select);
        };
        CartManager.sendToCart(payload, {
          onSuccess: function onSuccess() {
            flashSuccess();
          },
          onError: function onError() {
            showFloatingMessageCustom("Não foi possível adicionar este item.", "error");
          },
          onComplete: function onComplete() {
            UIHandlers.removeSelectSpinners($productContainer);
            $selects.each(function () {
              $(this).prop("disabled", false).removeClass("bt-loading").css("background-image", UIHandlers.SELECT_ARROW_BG);
            });
          }
        });
      });
    });
  })();

  /*
   * SEÇÃO 2: Botão de compra na página do produto
   */
  (function initProductPageButton() {
    var $mainBtn = $("#button-cart").last();
    if (!$mainBtn.length) return;
    var $btn = $("#btn-buy-now");
    if (!$btn.length) {
      var $newBtn = $("<button>", {
        id: "btn-buy-now",
        "class": "btn btn-lg btn-primary btn-buy-now",
        type: "button",
        text: "ADICIONAR AO CARRINHO"
      });
      $mainBtn.after($newBtn);
      $btn = $newBtn;
    }

    /*
     * Registrar evento no botão criado
     */
    $btn.on("click", function (e) {
      e.preventDefault();
      var $clickedBtn = $(this);
      var payload = PayloadBuilders.productPageButton();
      if (!payload || !payload.options || payload.options.length === 0) {
        showFloatingMessageCustom("Por favor, selecione as opções do produto antes de adicionar ao carrinho.", "error");
        return;
      }
      var originalText = $clickedBtn.text();
      $clickedBtn.prop("disabled", true).text("Adicionando...").css("opacity", "0.7");
      CartManager.sendToCart(payload, {
        onSuccess: function onSuccess() {},
        onError: function onError() {
          showFloatingMessageCustom("Não foi possível adicionar o produto ao carrinho.", "error");
        },
        onComplete: function onComplete() {
          $clickedBtn.prop("disabled", false).text(originalText).css("opacity", "1");
        }
      });
    });
  })();

  /*
   * SEÇÃO 3: Compre junto sem variações (produtos simples)
   */
  (function initBuyTogetherNoVariants() {
    CartManager.injectStyles("bt-loading-styles-no-variants", "\n      .bt-loading { cursor: wait; opacity:.85; }\n      .bt-inline-success {\n        position: absolute; top: 0; left: 0; width: 100%; height: 100%;\n        background: var(--cl-green); color: #fff; padding: 0 12px; border-radius: 6px;\n        display: flex; align-items: center; justify-content: center; gap: 8px;\n        font-size: 16px; line-height: 1; opacity: 0; transform: scale(.95);\n        transition: opacity .25s ease, transform .25s ease; pointer-events: none;\n      }\n      .bt-inline-success svg { width: 16px; height: 16px; flex: 0 0 16px; }\n      .bt-inline-success.show { opacity: 1; transform: scale(1); }\n      .bt-inline-success.hide { opacity: 0; transform: scale(.95); }\n      .btn-add-buy-together {\n        padding: 8px 16px; background-color: var(--cl-white, #fff); color: var(--cl-black); border: 1px solid var(--cl-grey-50); border-radius: 0;\n        cursor: pointer; font-size: 14px; font-weight: 500; transition: background-color 0.3s ease, color 0.3s ease;\n        width: 100%; position: relative;\n      }\n      .btn-add-buy-together:hover:not(:disabled) { opacity: 0.9; }\n      .btn-add-buy-together:disabled { cursor: wait; opacity: 0.7; }\n    ");
    function initButtons() {
      $(".buy-together").each(function () {
        var $product = $(this);
        var productId = $product.data("product-id");
        var hasSelect = $product.find(".select_list select.option_type_select").length > 0;
        if (!hasSelect && !$product.find(".btn-add-buy-together").length) {
          var $button = $("<button>", {
            type: "button",
            "class": "btn btn-sm btn-add-buy-together",
            text: "Adicionar ao carrinho",
            "data-product-id": productId
          });
          var $optionList = $product.find(".buy-together-option-list");
          if ($optionList.length) {
            $optionList.append($button);
          } else {
            var $newOptionList = $('<div class="buy-together-option-list"></div>');
            $newOptionList.append($button);
            $product.find(".buy-together-info").append($newOptionList);
          }
          $button.on("click", function (e) {
            e.preventDefault();
            var payload = PayloadBuilders.productWithoutVariations(productId, $product);
            if (!payload || !payload.options || payload.options.length === 0) {
              showFloatingMessageCustom("Não foi possível montar o pedido.", "error");
              return;
            }
            var originalText = $button.text();
            $button.prop("disabled", true).text("Adicionando...").css("opacity", "0.7");
            CartManager.debounce("no-variant-".concat(productId), function () {
              CartManager.sendToCart(payload, {
                onSuccess: function onSuccess() {
                  UIHandlers.showButtonSuccess($button, originalText);
                },
                onError: function onError() {
                  showFloatingMessageCustom("Não foi possível adicionar este item.", "error");
                  $button.prop("disabled", false).text(originalText).css("opacity", "1");
                },
                onComplete: function onComplete() {}
              });
            });
          });
        }
      });
    }
    initButtons();

    /*
     * Observer para produtos carregados dinamicamente
     */
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.addedNodes.length) {
          initButtons();
        }
      });
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  })();
});
function showFloatingMessageCustom(message) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "default";
  var allowed = ["success", "error", "default"];
  var resolvedType = allowed.includes(type) ? type : "default";
  if (!document.getElementById("toast-container")) {
    var _container = document.createElement("div");
    _container.id = "toast-container";
    document.body.appendChild(_container);
  }
  var container = document.getElementById("toast-container");
  var toast = document.createElement("div");
  toast.className = "toast toast--".concat(resolvedType);
  toast.textContent = message;
  container.appendChild(toast);
  requestAnimationFrame(function () {
    toast.classList.add("show");
  });
  setTimeout(function () {
    toast.classList.remove("show");
    toast.classList.add("hide");
    setTimeout(function () {
      toast.remove();
      if (container.children.length === 0) {
        container.remove();
      }
    }, 350);
  }, 3500);
}

/***/ })
/******/ 	]);
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry needs to be wrapped in an IIFE because it needs to be in strict mode.
(() => {
"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _header_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
/* harmony import */ var _header_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_header_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _cart_send_to_cart_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2);
/* harmony import */ var _cart_send_to_cart_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_cart_send_to_cart_js__WEBPACK_IMPORTED_MODULE_1__);
/*Para minificar o arquivo rode
    gulp watchJs --fn=custom --src=catalog/view/theme/jacometti_v4/javascript
*/



/*ANCHOR Módulo de lista de produtos em carrossel*/
$(function () {
  var $swipersProductModule = $(".product_module");
  var $swipersProductModuleSwiper = $swipersProductModule.find(".swiper");
  $swipersProductModuleSwiper.each(function () {
    var $parent = $(this).parent(".product_module");
    moveSwiperNavigation($parent);
  });
  $swipersProductModule.each(function () {
    addSeeMoreButton($(this));
  });
  function moveSwiperNavigation($parent) {
    var windowWidth = window.innerWidth;
    if (!$parent || !$parent.length || windowWidth < 1280) return;
    $parent.find(".swiper").each(function () {
      var $swiper = $(this);
      var $next = $swiper.find(".swiper-button-next");
      var $prev = $swiper.find(".swiper-button-prev");
      if (!$next.length || !$prev.length) return;
      if ($parent.find(".swiper-navigation").length) return;
      var $navWrapper = $('<div class="swiper-navigation"></div>');
      $navWrapper.append($prev, $next);
      $swiper.after($navWrapper);
    });
  }
  function addSeeMoreButton($element) {
    var $seeMoreLink = $element.find(".heading-title a").attr("href");
    if (!$seeMoreLink) return;
    var $seeMore = $("\n                  <a href=\"".concat($seeMoreLink, "\" class=\"see-more-link\">ver mais</a>\n              "));
    $element.append($seeMore);
  }
});

/*ANCHOR [INÍCIO] - Página de categoria | busca*/
$(function () {
  var PAGE_CATEGORY = $(".page-product-category");
  var PAGE_SEARCH = $(".page-product-search");
  if (!PAGE_CATEGORY.length && !PAGE_SEARCH.length) return;

  /*[1 -> Início] - Construir barra superior*/
  createTopStructure();

  /*[2 -> Início] - Adicionar backdrop nos filtros*/
  addBackdropFilters();

  /*[3 -> Início] - Construir barra de filtros do topo*/
  createTopFilterBar();

  /*[4 -> Início] - Criar 'ver mais' na descrição da categoria*/
  categoryDescriptionShowMore();
});

/*ANCHOR [INÍCIO] - Página do produto*/
$(function () {
  var PAGE_PRODUCT = $(".page-product-product");
  if (!PAGE_PRODUCT.length) return;

  /*[1 -> Início] - Formatar título do produto*/
  var $product_title = $("#product .product-title");
  formatTitle("product", $product_title, 2);

  /*[2 -> Início] - Reposicionar guia de tamanho ao lado de grade de estoque (tamanhos)*/
  changeSizeGuideButtonPosition();

  /*[3 -> Início] - Reposicionar preço do produto abaixo do título*/
  changeProductPricePosition();

  /*[4 -> Início] - Criar carrossel de produtos relacionados*/
  createRelatedProductsCarousel();

  /*[5 -> Início] - Trocar quantidade visível de imagens do carrossel*/
  setTimeout(updateProductCarousel, 0);
  window.addEventListener("resize", updateProductCarousel);

  /*[6 -> Início] - Ajustar espaçamento do carrossel de imagens do produto*/
  setTimeout(function () {
    updateProductImgThumbs();
    updateProductImgMain();
  }, 1500);

  /*[7 -> Início] - Alterar posicionamento e estilo do botão de compartilhamento*/
  changeShareButtonLayoutAndPosition();

  /*[8 -> Início] - Alterar posicionamento de avaliações*/
  changeProductReviewsPosition();

  /*[9 -> Início] - Alterar posicionamento do guia de tamanhos*/
  changeSizeGuidePosition();

  /*[10 -> Início] - Mover botão de consultar para área de compra*/
  moveConsultButtonBuyWhatsapp();

  /*ANCHOR [COMPRE JUNTO]*/
  /*[1 -> Início] - Formatar título do compre junto*/
  var buyTogetherTitles = $(".buy-together-content .product-buy-together-title");
  buyTogetherTitles.each(function () {
    formatTitle("buy-together", $(this), 3);
  });

  /*[2 -> Início] - Redimensionar o carrossel do compre junto*/
  setTimeout(function () {
    resizebuyTogether();
  }, 1000);
  window.addEventListener("resize", resizebuyTogether);

  /*ANCHOR [Produtos relacionados]*/
  /*[1 -> Início] - Trocar quantidade visível de imagens do carrossel*/
  setTimeout(function () {
    updateProductRelated();
  }, 100);
  window.addEventListener("resize", updateProductRelated);
});

/*ANCHOR [ÍNICIO] - Página de combo*/
$(function () {
  updateSwiperCategories();
  changeComboDescriptionPosition();
  overrideComboSwiper();
});

/*ANCHOR [ÍNICIO] - Página do carrinho*/
$(function () {
  var PAGE_CART = $(".page-checkout-cart");
  if (!PAGE_CART.length) return;
  countCartTotalItems();
});

/*ANCHOR [FUNÇÕES]*/
function updateProductCarousel() {
  var _$$;
  var $productMainCarousel = (_$$ = $(".product-image .productMainCarousel")[0]) === null || _$$ === void 0 ? void 0 : _$$.swiper;
  if ($productMainCarousel) {
    var windowWidth = window.innerWidth;
    $productMainCarousel.params.slidesPerView = windowWidth > 1024 ? 1 : 1.3;
    $productMainCarousel.params.spaceBetween = 8;
    $productMainCarousel.update();
  }
}
function updateProductRelated() {
  var _$$2;
  var $productMainCarousel = (_$$2 = $(".products-related-content #products-related")[0]) === null || _$$2 === void 0 ? void 0 : _$$2.swiper;
  if ($productMainCarousel) {
    var windowWidth = window.innerWidth;
    $productMainCarousel.params.slidesPerView = windowWidth > 1024 ? 4 : 2.3;
    $productMainCarousel.params.spaceBetween = windowWidth > 1024 ? 70 : 10;
    $productMainCarousel.update();
  }
}
function updateSwiperCategories() {
  var swiperEl = document.querySelector(".swipper_banner_carousel_140");
  var swiperInstance = swiperEl === null || swiperEl === void 0 ? void 0 : swiperEl.swiper;
  if (!swiperInstance) return;
  var windowWidth = window.innerWidth;
  swiperInstance.params.breakpoints = {
    0: {
      spaceBetween: 12
    },
    1280: {
      spaceBetween: 80
    },
    1600: {
      spaceBetween: 150
    }
  };
  swiperInstance.update();
  swiperInstance.updateSlides();
  swiperInstance.updateSize();
}
function updateProductImgThumbs() {
  var _$$3;
  var $productThumbsCarousel = (_$$3 = $(".product-single .productThumbsCarousel")[0]) === null || _$$3 === void 0 ? void 0 : _$$3.swiper;
  if ($productThumbsCarousel) {
    $productThumbsCarousel.params.spaceBetween = 8;
    $productThumbsCarousel.update();
  }
}
function updateProductImgMain() {
  var swiperElement = document.querySelector(".product-single .productMainCarousel");
  var swiperInstance = swiperElement === null || swiperElement === void 0 ? void 0 : swiperElement.swiper;
  var windowWidth = window.innerWidth;
  if (!swiperInstance || windowWidth <= 1024) return;
  swiperInstance.changeDirection("vertical", false);
  Object.assign(swiperInstance.params, {
    spaceBetween: 8,
    slidesPerView: 1,
    freeMode: true,
    mousewheel: {
      enabled: true,
      sensitivity: 1,
      releaseOnEdges: true,
      eventsTarget: "container"
    }
  });
  if (swiperInstance.el && swiperInstance.mousewheel) {
    swiperInstance.mousewheel.enable();
  }
  swiperInstance.updateAutoHeight();
  swiperInstance.update();
}
function changeProductReviewsPosition() {
  var $productReviews = $("#product .product-rating");
  var $share = $(".product-share-link");
  $share.prepend($productReviews);
}
function changeSizeGuidePosition() {
  if (screen.width < 1024) return;
  var $sizeGuide = $(".product-shop-informations-group");
  var $sizeGuideBackdrop = $(".tab-backdrop");
  var $header = $("header");
  $header.append($sizeGuide, $sizeGuideBackdrop);
}
;
function changeProductPricePosition() {
  var $productPriceBody = $("#product .product-price-body");
  var $product_title = $("#product .product-title");
  $product_title.after($productPriceBody).fadeIn("slow");
}
function createRelatedProductsCarousel() {
  var $productsLikeslist = $("#product .product-likes-content .list-inline");
  if (!$productsLikeslist.length) return;
  $productsLikeslist.addClass("swiper-wrapper");
  $productsLikeslist.find("li").addClass("swiper-slide");
  $productsLikeslist.wrap('<div class="swiper related-swiper"><div class="swiper-container"></div></div>');
  $(".related-swiper .swiper-container").append($productsLikeslist);
  $(".related-swiper").append("\n                    <div class=\"swiper-button-prev\"></div>\n                    <div class=\"swiper-button-next\"></div>\n                ");
  new Swiper(".related-swiper .swiper-container", {
    slidesPerView: 3.5,
    spaceBetween: 16,
    navigation: {
      nextEl: ".related-swiper .swiper-button-next",
      prevEl: ".related-swiper .swiper-button-prev"
    },
    breakpoints: {
      768: {
        slidesPerView: 4.5
      },
      1024: {
        slidesPerView: 5.5
      }
    }
  });
}
function changeSizeGuideButtonPosition() {
  var $productOptionSizes = $('#product .product-radio-title:contains("Tamanho")');
  var $productSizeGuide = $("#product .product-size-guide");
  var $sizeGuideAndOptionStructure = $("\n        <div class=\"product-size-guide-and-option\">\n            <span>".concat($productOptionSizes.prop("outerHTML"), "</span>\n        </div>\n    "));
  if ($productOptionSizes.length > 0) {
    $sizeGuideAndOptionStructure.append($productSizeGuide);
    $productOptionSizes.replaceWith($sizeGuideAndOptionStructure);
  }
}
function changeShareButtonLayoutAndPosition() {
  var $shareContainer = $(".product-share-link");
  var $shareList = $shareContainer.find("ul");
  var $socialItems = $shareList.find("li:not(.title)");
  $socialItems.hide();
  var $shareButton = $("<button>", {
    "class": "share-toggle-btn",
    html: "\n            <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" fill=\"none\">\n                <g clip-path=\"url(#clip0_170_8937)\">\n                    <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M6.15535 12.3092C6.76739 12.3092 7.35436 12.0661 7.78713 11.6333C8.21991 11.2005 8.46304 10.6135 8.46304 10.0015C8.46304 9.38946 8.21991 8.80249 7.78713 8.36972C7.35436 7.93694 6.76739 7.69381 6.15535 7.69381C5.54331 7.69381 4.95634 7.93694 4.52356 8.36972C4.09079 8.80249 3.84766 9.38946 3.84766 10.0015C3.84766 10.6135 4.09079 11.2005 4.52356 11.6333C4.95634 12.0661 5.54331 12.3092 6.15535 12.3092ZM6.15535 9.23227C6.35936 9.23227 6.55502 9.31332 6.69928 9.45757C6.84354 9.60183 6.92458 9.79749 6.92458 10.0015C6.92458 10.2055 6.84354 10.4012 6.69928 10.5454C6.55502 10.6897 6.35936 10.7707 6.15535 10.7707C5.95134 10.7707 5.75568 10.6897 5.61142 10.5454C5.46716 10.4012 5.38612 10.2055 5.38612 10.0015C5.38612 9.79749 5.46716 9.60183 5.61142 9.45757C5.75568 9.31332 5.95134 9.23227 6.15535 9.23227ZM13.0784 8.46304C13.6905 8.46304 14.2774 8.21991 14.7102 7.78713C15.143 7.35436 15.3861 6.76739 15.3861 6.15535C15.3861 5.54331 15.143 4.95634 14.7102 4.52356C14.2774 4.09079 13.6905 3.84766 13.0784 3.84766C12.4664 3.84766 11.8794 4.09079 11.4466 4.52356C11.0139 4.95634 10.7707 5.54331 10.7707 6.15535C10.7707 6.76739 11.0139 7.35436 11.4466 7.78713C11.8794 8.21991 12.4664 8.46304 13.0784 8.46304ZM13.0784 5.38612C13.2824 5.38612 13.4781 5.46716 13.6224 5.61142C13.7666 5.75568 13.8477 5.95134 13.8477 6.15535C13.8477 6.35936 13.7666 6.55502 13.6224 6.69928C13.4781 6.84354 13.2824 6.92458 13.0784 6.92458C12.8744 6.92458 12.6788 6.84354 12.5345 6.69928C12.3902 6.55502 12.3092 6.35936 12.3092 6.15535C12.3092 5.95134 12.3902 5.75568 12.5345 5.61142C12.6788 5.46716 12.8744 5.38612 13.0784 5.38612ZM13.0784 16.1553C13.6905 16.1553 14.2774 15.9122 14.7102 15.4794C15.143 15.0467 15.3861 14.4597 15.3861 13.8477C15.3861 13.2356 15.143 12.6486 14.7102 12.2159C14.2774 11.7831 13.6905 11.54 13.0784 11.54C12.4664 11.54 11.8794 11.7831 11.4466 12.2159C11.0139 12.6486 10.7707 13.2356 10.7707 13.8477C10.7707 14.4597 11.0139 15.0467 11.4466 15.4794C11.8794 15.9122 12.4664 16.1553 13.0784 16.1553ZM13.0784 13.0784C13.2824 13.0784 13.4781 13.1595 13.6224 13.3037C13.7666 13.448 13.8477 13.6436 13.8477 13.8477C13.8477 14.0517 13.7666 14.2473 13.6224 14.3916C13.4781 14.5358 13.2824 14.6169 13.0784 14.6169C12.8744 14.6169 12.6788 14.5358 12.5345 14.3916C12.3902 14.2473 12.3092 14.0517 12.3092 13.8477C12.3092 13.6436 12.3902 13.448 12.5345 13.3037C12.6788 13.1595 12.8744 13.0784 13.0784 13.0784Z\" fill=\"#65735A\"/>\n                    <path d=\"M7.10255 9.83L6.51562 8.83692L11.7395 5.75L12.3264 6.74308L7.10255 9.83ZM11.7341 14.2546L12.3279 13.2654L7.49255 10.3638L6.8987 11.3531L11.7341 14.2546Z\" fill=\"#65735A\"/>\n                    <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M10 18.4615C14.6731 18.4615 18.4615 14.6731 18.4615 10C18.4615 5.32692 14.6731 1.53846 10 1.53846C5.32692 1.53846 1.53846 5.32692 1.53846 10C1.53846 14.6731 5.32692 18.4615 10 18.4615ZM10 20C15.5231 20 20 15.5231 20 10C20 4.47692 15.5231 0 10 0C4.47692 0 0 4.47692 0 10C0 15.5231 4.47692 20 10 20Z\" fill=\"#65735A\"/>\n                </g>\n                <defs>\n                    <clipPath id=\"clip0_170_8937\">\n                    <rect width=\"20\" height=\"20\" fill=\"white\"/>\n                    </clipPath>\n                </defs>\n            </svg>\n            <span>COMPARTILHAR</span>\n        "
  });
  $shareContainer.prepend($shareButton);
  $shareButton.on("click", function () {
    $(this).toggleClass("active");
    if ($(this).hasClass("active")) {
      $socialItems.each(function (i) {
        $(this).delay(100 * i).fadeIn(200).css("display", "inline-block");
      });
    } else {
      $socialItems.fadeOut(200);
    }
  });
}
;
function moveConsultButtonBuyWhatsapp() {
  var $consultButton = $("#product .consult_button_buy_whatsapp");
  var $productShopContent = $("#product .product-shop-content");
  $productShopContent.append($consultButton);
}
function overrideComboSwiper() {
  var _$$4;
  var $swiperEl = (_$$4 = $(".combo-swiper-thumb")[0]) === null || _$$4 === void 0 ? void 0 : _$$4.swiper;
  var windowWidth = window.innerWidth;
  if ($swiperEl && windowWidth > 1024) {
    $swiperEl.changeDirection("vertical", false);
    $swiperEl.params.spaceBetween = 8;
    $swiperEl.updateAutoHeight();
    $swiperEl.update();
  }
}
function changeComboDescriptionPosition() {
  var PAGE_COMBO_V2 = $(".page-product-Combo-getComboPage");
  if (!PAGE_COMBO_V2.length) return;
  var $comboCotent = $(".combo-content");
  var $comboDescription = $(".combo-description--desktop");
  $comboCotent.after($comboDescription);
}
function categoryDescriptionShowMore() {
  /*[4 -> Início] - Criar 'ver mais' na descrição da categoria*/
  var windowWidth = window.innerWidth;
  var $categoryDescription = $(".category-description");
  var $showMoreCategoryDescription = $('<span class="category-description--show-more">ver mais</span>');
  var $categoryTitle = $("\n        <h5 class=\"category-description__title\">".concat($(".category-heading-title").text(), "</h5>\n    "));
  if (!$(".category-description").text().trim().length) return;
  if (windowWidth <= 1024) {
    $categoryDescription.append($showMoreCategoryDescription);
  }
  $categoryDescription.prepend($categoryTitle);
  $showMoreCategoryDescription.on("click", function () {
    $categoryDescription.toggleClass("show");
    $showMoreCategoryDescription.text() == "ver mais" ? $showMoreCategoryDescription.text("ver menos") : $showMoreCategoryDescription.text("ver mais");
  });
}
function createTopFilterBar() {
  var windowWidth = window.innerWidth;
  if (windowWidth < 1024) {
    var $clearFiltersButton = $("\n            <button class=\"clear-filters\">\n                LIMPAR FILTROS\n            </button>\n        ");
    var $containerBottomFilter = $(".filterActionContainer--bottom");
    $containerBottomFilter.append($clearFiltersButton);
    $clearFiltersButton.on("click", function (e) {
      e.preventDefault();
      clearFilters();
    });
  } else {
    var $filterFormTop = $("#content-filters-v2--top .filterForm--content_top");
    var $itemsSelected = $("#content-filters-v2--top .buttons");
    var $clearFiltersButtonOriginal = $("#content-filters-v2--top .clear-filters");
    var $applyFiltersButton = $("#content-filters-v2--top .filterActionContainer--bottom");
    var $structureFilterTop = $('<div class="structure-top-bar"></div>');
    var $customTopStructure = $(".custom-top-structure");
    $applyFiltersButton.prepend($clearFiltersButtonOriginal);
    $structureFilterTop.append($itemsSelected, $applyFiltersButton);
    $filterFormTop.append($structureFilterTop);
    $customTopStructure.addClass("show");
    $clearFiltersButtonOriginal.on("click", function (e) {
      e.preventDefault();
      clearFilters();
    });
  }
}
function addBackdropFilters() {
  var windowWidth = window.innerWidth;
  var $openFiltersButton = $('[id^="content-filters-v2"] .filterContent__title ');
  var $closeFiltersButton = $('[id^="content-filters-v2"] .js-close-filters');
  if (windowWidth <= 1024) {
    $openFiltersButton.on("click", function () {
      window.openFilters();
    });
  }
  $closeFiltersButton.on("click", function () {
    window.closeFilters();
  });
}
function createTopStructure() {
  var windowWidth = window.innerWidth;
  var $breadcrumb = $(".breadcrumb");
  var $productList = $(".product-categories-container");
  var $sectionContent = $(".section-content");
  var $filterV2 = windowWidth > 1024 ? $("#content-filters-v2--top") : $("#content-filters-v2--left");
  var $toolbarShop = $(".toolbar-shop");
  var $customTopStructure = $('<div class="custom-top-structure"></div>');
  $sectionContent.prepend($breadcrumb);
  $customTopStructure.append($filterV2, $toolbarShop);
  $productList.before($customTopStructure);
}

/**
 * Função que formata o título em dois spans seperados, possibilidando estilização personalizada para cada um das partes.
 *
 * className -> Nome da classe dos elementos de spans. Pode ser inserido o local, exemplo product.
 * $element -> Elemento em que a alteração será feita.
 * slice -> Posição em que o título será separado.
 */
function formatTitle(className, $element, slice) {
  var initial_title = $element.text().split(" ").slice(0, slice).join(" ");
  var final_title = $element.text().split(" ").slice(slice).join(" ");
  var $new_title_structure = $("\n        <span class=\"".concat(className, "-initial-title\">").concat(initial_title, "</span>\n        <span class=\"").concat(className, "-final-title\">").concat(final_title, "</span>\n    "));
  $element.html($new_title_structure).fadeIn("slow");
}
function resizebuyTogether() {
  if (window.innerWidth < 1024) return;
  var $buyTogetherMainImg = $(".buy-together-main-image").height();
  $(".buy-together-items-content").css("max-height", $buyTogetherMainImg);
}
function countCartTotalItems() {
  var PAGE_CART = $(".page-checkout-cart");
  if (!PAGE_CART.length) return;
  var totalItems = 0;
  var cartItems = $("#cart-quantity").text();
  var $subTotalTitle = $(".cart-total-item__title").first();
  var newTextQuantityItems = "Quantidade de itens (".concat(cartItems < 10 ? "0".concat(cartItems) : cartItems, ")");
  $subTotalTitle.text(newTextQuantityItems).css("color", "var(--cl-black)");
  return totalItems;
}
})();

/******/ })()
;